
export const AUTH_LOGOUT = 'Successfully logged out.';

// export const MODEL_CREATE = 'Successfully created...';
// export const MODEL_DELETE = 'Successfully deleted...';
// export const MODEL_UPDATE = 'Successfully updated...';
